var _rect, _rect2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeaturesTwoShades3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "232.4px",
    height: "302px",
    viewBox: "0 0 232.4 302",
    enableBackground: "new 0 0 232.4 302",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 37.6,
    fill: "none",
    stroke: "#646463",
    strokeWidth: 1.7568,
    strokeMiterlimit: 10,
    width: 198.4,
    height: 226.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.2,
    y: 51.8,
    fill: "none",
    stroke: "#646463",
    strokeWidth: 1.7321,
    strokeMiterlimit: 10,
    width: 170.1,
    height: 198.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.7872,
    strokeMiterlimit: 10,
    d: "M116.6,219.8c0,0,0,2-0.3,2.9 c-0.6,1.4,0.4,1.8,0.4,1.8h82.4c0,0,0.9-0.2,0.4-1.6c-0.3-1.7-0.6-3.1-0.6-3.1H116.6L116.6,219.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.7872,
    strokeMiterlimit: 10,
    d: "M116.6,215.6c0,0,0.1,1.5-0.3,2.9 c-0.9,1.8,0.4,1.8,0.4,1.8h82.4c0,0,0.9-0.2,0.4-1.6c-0.3-1.7-0.6-3.1-0.6-3.1H116.6L116.6,215.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.7872,
    strokeMiterlimit: 10,
    d: "M118.7,55h80.6L199,188.6 c0,0,0.1,0.9,0,3.4c0.4,1.5,0.8,23.9-0.4,23.9c-1.3,0-78.2,0-81.4,0c-2.3,0-0.7-22-0.9-26.6c0-1.1,0-134.2,0-134.2L118.7,55 L118.7,55z"
  })), /*#__PURE__*/React.createElement("line", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.7872,
    strokeMiterlimit: 10,
    x1: 116.3,
    y1: 78.1,
    x2: 199.2,
    y2: 78.1
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.7872,
    strokeMiterlimit: 10,
    x1: 116.3,
    y1: 104.6,
    x2: 199.2,
    y2: 104.6
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.7872,
    strokeMiterlimit: 10,
    x1: 116.3,
    y1: 132.4,
    x2: 199.2,
    y2: 132.4
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.7872,
    strokeMiterlimit: 10,
    x1: 116.3,
    y1: 161.7,
    x2: 199.2,
    y2: 161.7
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.7872,
    strokeMiterlimit: 10,
    x1: 116.3,
    y1: 190.6,
    x2: 199.2,
    y2: 190.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.7872,
    strokeMiterlimit: 10,
    d: "M33.5,190.5c0,0,0,2-0.3,2.9 c-0.6,1.4,0.4,1.8,0.4,1.8H116c0,0,0.9-0.2,0.4-1.6c-0.3-1.7-0.6-3.1-0.6-3.1H33.5L33.5,190.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.7872,
    strokeMiterlimit: 10,
    d: "M33.5,186.3c0,0,0.1,1.5-0.3,2.9 c-0.9,1.8,0.4,1.8,0.4,1.8H116c0,0,0.9-0.2,0.4-1.6c-0.3-1.7-0.6-3.1-0.6-3.1H33.5L33.5,186.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.7872,
    strokeMiterlimit: 10,
    d: "M35.6,55.3h80.6l-0.2,104 c0,0,0.1,0.9,0,3.4c0.4,1.5,0.8,23.9-0.4,23.9c-1.3,0-78.2,0-81.4,0c-2.3,0-0.7-22-0.9-26.6c0-1.1,0-104.6,0-104.6L35.6,55.3 L35.6,55.3z"
  })), /*#__PURE__*/React.createElement("line", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.7872,
    strokeMiterlimit: 10,
    x1: 33.1,
    y1: 78.2,
    x2: 116.1,
    y2: 78.2
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.7872,
    strokeMiterlimit: 10,
    x1: 33.5,
    y1: 104.5,
    x2: 116.4,
    y2: 104.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.7872,
    strokeMiterlimit: 10,
    x1: 33.1,
    y1: 132.5,
    x2: 116.1,
    y2: 132.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.7872,
    strokeMiterlimit: 10,
    x1: 33.1,
    y1: 161.3,
    x2: 116.1,
    y2: 161.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesTwoShades3);
export default __webpack_public_path__ + "static/media/FeaturesTwoShades3.01bfc4c5309f3547714f261f09887a59.svg";
export { ForwardRef as ReactComponent };